import Application from "./Application";
import PreloaderScene from "./../scenes/PreLoader";
import Common from "./Common";

/**
 * @class
 */
export default class Main {
    /**
     * @param {number} width
     * @param {number} height
     */
    constructor(width, height) {

        /**
         * @member {!number}
         * @private
         */
        this._width = width;

        /**
         * @member {!number}
         * @private
         */
        this._height = height;

        /**
         * @member {GenericPreloaderScene}
         * @private
         */
        this._preloader = null;

        /**
         * @member {Application}
         * @private
         */
        this._game = null;
    }

    init() {

        //HACKS
        PIXI.Mesh.DRAW_MODES = PIXI.DRAW_MODES;

        P3.assets.audioFileTypes = ["ogg", "mp3"];

        global.Common = Common;

        //Common.language = language;
        Common.language = "en";

        PIXI.settings.RETINA_PREFIX = /\_(?=[^_]*$)(.+)x/;

        TweenMax.defaultOverwrite = "none";
        TweenLite.lagSmoothing();

        const options = {
            width: this._width,
            height: this._height,
            holderId: "game",
            portrait: false,
            rotateImageUrl: "assets/images/rotate.jpg",
            rotateImageColor: "#000000",
            aspectRatioFillHeight: true
        };

        const view = new P3.View(options);
        view.signals.ready.once(function (canvas) {
            const options = {};
            options.view = canvas;
            options.transparent = false;
            options.antialias = true;
            options.preserveDrawingBuffer = false;// TODO - do we want this?
            options.clearBeforeRender = true;
            options.resolution = 0.9;
            options.width = window.innerWidth;
            options.height = window.innerHeight;

            const stage = new PIXI.Container();
            Common.stage = stage;

            P3.input.init(stage, canvas);

            if (P3.utils.isCocoonJS()) {
                stage.scale.x = window.innerHeight / this._height;
                stage.scale.y = window.innerHeight / this._height;
                console.log(stage.scale.x, stage.scale.y, window.innerWidth, window.innerHeight);
            }

            const renderer = new PIXI.Renderer(options);
            renderer.backgroundColor = 0x0;
            Common.renderer = renderer;
            Common.isWebGL = true;

            P3.assets.texture = function (name, extension) {
                extension = "." + (extension || "png");

                let texture;
                if (this._resources[name]) {
                    texture = this._resources[name].texture;
                } else {
                    try {
                        texture = PIXI.Texture.from(name + extension);
                    } catch (error) {
                        console.warn("texture not found :", name);
                        texture = this._fallbackTexture;
                    }
                }
                return texture;
            };

            //added an extra function to sample just a single pixel
            renderer.extract.samplePixel = function (target, x, y) {

                const renderer = this.renderer;
                let resolution;
                let renderTexture;
                let generated = false;
                if (target) {
                    renderTexture = this.renderer.generateTexture(target);
                    generated = true;
                }
                if (renderTexture) {
                    resolution = renderTexture.baseTexture.resolution;
                    // bind the buffer
                    renderer.renderTexture.bind(renderTexture);
                }
                else {
                    resolution = renderer.resolution;
                    renderer.renderTexture.bind(null);
                }

                const webglPixels = new Uint8Array(4);
                // read pixels to the array
                const gl = renderer.gl;
                gl.readPixels(
                    x * resolution,
                    y * resolution,
                    1,
                    1,
                    gl.RGBA,
                    gl.UNSIGNED_BYTE,
                    webglPixels
                );
                if (generated) {
                    renderTexture.destroy(true);
                }
                return webglPixels;
            };

            stage.addChild(P3.scene.view);

            const ticker = new P3.Ticker();
            ticker.init(() => {
                P3.scene.update();
                P3.input.update();
                window.deltaTime = P3.Ticker.dt;
            }, () => {
                renderer.render(Common.stage);
            });

            window.delay = function (callback, delay, scope) {
                return TweenMax.delayedCall(delay, callback, [], scope);
            };
            window.delayarg = function (callback, delay, args, scope) {
                return TweenMax.delayedCall(delay, callback, args, scope);
            };
            window.translate = function (str) {
                let s = Common.config.strings[str];
                s = s && s[Common.language];
                return (typeof s !== "undefined") ? s : str;
            };

            this.loadPreloader();
        }, this);
        view.signals.resize.add(this.onCanvasResize, this);
        //view.init();
        Common.view = view;
        this.loadConfig(function () {
            view.init()
        }, this);    // we load the config before we do anything
    }

    loadConfig(callback, scope) {
        scope = scope || window;
        P3.assets.addFiles([{name: "config", url: "config" + ".json"}], "./");
        P3.assets.signals.complete.once(function () {
            Common.config = P3.assets.json("config");
            callback && callback.call(scope);
        }, this);
        P3.assets.load();
    }

    loadPreloader() {
        const files = [
            {name: "preloader_bar", url: "images/" + "preloader_bar" + ".png"}
        ];

        if (files.length) {
            P3.assets.addFiles(files, "assets/");
            P3.assets.signals.complete.once(function () {
                this.loadAssets();
            }, this);
            P3.assets.load();
        } else {
            this.loadAssets();
        }
    }

    loadAssets() {
        const ext = P3.assets.audioFileExt;
        console.log(ext);

        const files = [
            {name: "particle", url: "images/" + "particle" + ".png"},
            //--data--//
            {name: "copy", url: "data/" + "copy" + ".json"},
            //--sheets--//
            {name: "ui_shared_1x", url: "images/" + "ui_shared_1x" + ".json"},
            {name: "buttons_1x", url: "images/" + "buttons_1x" + ".json"},
            //--textures (same as normal textures just different dir)--//
            {name: "default", url: "3d/" + "default" + ".png"},
            {name: "sky", url: "3d/" + "sky" + ".png"},
            {name: "quad_and_satellite_diffuse", url: "3d/" + "quad_and_satellite_diffuse" + ".jpg"},
            //--sounds--//
            {name: "sfx_carousel_slide_00", url: "audio/" + "sfx_carousel_slide_00" + ext},
            {name: "sfx_btn_press_generic_00", url: "audio/" + "sfx_btn_press_generic_00" + ext},
            {name: "sfx_btn_rollover_00", url: "audio/" + "sfx_btn_rollover_00" + ext}

        ];

        const meshes = [
            {name: "space"},
            {name: "satellite"}
        ];

        if (meshes.length) {
            const meshLoader = new P3D.Loader();
            for (let i = 0; i < meshes.length; i++) {
                meshLoader.load(meshes[i].name);
            }
            P3.assets.mesh = meshLoader.mesh.bind(meshLoader);
            console.log(meshLoader);
        }

        if (files.length) {

            this._preloader = new PreloaderScene();
            P3.scene.add(this._preloader);

            P3.assets.addFiles(files, "assets/");
            P3.assets.signals.progress.add(this.onLoadingProgress, this);
            P3.assets.signals.complete.once(this.onLoadingCompleted, this);
            P3.assets.load();

        } else {
            this.startGame();
        }
    }

    static createConfig() {
        Common.config = {};
    }

    /**
     * @param [t=0]
     */
    startGame(t = 0) {
        delay(function () {
            this._game = new Application();
            this._game.init();
        }, t, this);
    }

    /**
     * @param {Event} event
     */
    onLoadingProgress(event) {
        this._preloader.loaded = event.progress / 100.0;
    }

    onLoadingCompleted() {
        P3.assets.signals.progress.detachAll();
        P3.assets.signals.complete.detachAll();

        this._preloader.loaded = 1;

        this._preloader.onLoadComplete();

        this._preloader.signals.next.add(() => this.startGame(0));
    }

    /**
     * @param {boolean} correct
     */
    onCanvasResize(correct) {
        if (correct) {
            Common.renderer.resize(P3.View.width, P3.View.height);
            if (P3.scene) {
                P3.scene.resize();
            }
        }
    }
}

function createText(copy, config, style = "med") {
    config = config || {};
    const cfg = config;
    let textView;
    if (Common.language === "ar") {

    } else {

        if (style === "med") {
            cfg.fontFamily = "Cervo Medium";
        } else {
            cfg.fontFamily = "Cervo Thin";
        }

        cfg.fontSize = config.size || config.fontSize || 45;
        if (config.fill !== undefined && config.fill !== null) {
            cfg.fill = config.fill;
        } else {
            cfg.fill = 0x0;
        }

        cfg.align = config.align || "left";
        cfg.letterSpacing = config.letterSpacing || 0;
        if (config.stroke) {
            cfg.stroke = config.stroke;
            cfg.strokeThickness = config.strokeThickness || 8;
        }
        if (config.wordWrap || cfg.wordWrapWidth) {
            cfg.wordWrap = true;
            cfg.wordWrapWidth = config.wordWrapWidth;
        }
        if (config.dropShadow || cfg.dropShadowDistance) {
            cfg.dropShadow = true;
            cfg.dropShadowDistance = config.dropShadowDistance || 8;
        }

        textView = new PIXI.Text(copy, cfg);
        textView.resolution = 1.5;


    }
    return textView;
}

window.createText = createText;

function createButton(icon, type, iconStates) {

    let buttonStates;

    if (icon && icon !== "") {
        buttonStates = new P3.ButtonStates(
            P3.assets.texture('btn_' + type + '_out'),
            P3.assets.texture('btn_' + type + '_out'),
            P3.assets.texture('btn_' + type + '_down')
        );
        if (!iconStates) {
            buttonStates.iconOver = P3.assets.texture("icon_" + icon);
            buttonStates.iconDown = P3.assets.texture("icon_" + icon);
        } else {
            buttonStates.icon = P3.assets.texture("icon_" + icon + "_out");
            buttonStates.iconDown = P3.assets.texture("icon_" + icon + "_down");
        }

    } else {
        buttonStates = new P3.ButtonStates(
            P3.assets.texture('btn_' + type + '_out'),
            P3.assets.texture('btn_' + type + '_out'),
            P3.assets.texture('btn_' + type + '_down')
        );
    }

    let button;
    if (icon === 'sound') {
        buttonStates.iconAlt = P3.assets.texture('icon_' + "mute");
        // buttonStates.iconOverAlt = P3.assets.texture('icon_' + "mute");
        buttonStates.iconDownAlt = P3.assets.texture('icon_' + "mute");
        button = new P3.MuteButton(buttonStates);
    }
    else {
        button = new P3.Button(buttonStates);
    }

    button.overSoundName = "sfx_btn_rollover_00";
    button.clickSoundName = "sfx_btn_press_generic_00";

    return button;
}

window.createButton = createButton;

function create9Slice(textureName, width, height) {

    const holder = new PIXI.Container();
    const texture = P3.assets.texture(textureName);

    width = width || texture.width;
    height = height || texture.height;

    const nineSlice = new PIXI.NineSlicePlane(texture, 15, 15, 15, 15);

    nineSlice.width = width;
    nineSlice.height = height;

    holder.addChild(nineSlice);

    nineSlice.x = -width * 0.5;
    nineSlice.y = -height * 0.5;

    holder.nineSlice = nineSlice;

    return holder;
}

window.create9Slice = create9Slice;

function lhs() {
    return (Common.STAGE_WIDTH - P3.View.width) * 0.5;
}

window.lhs = lhs;

function rhs() {
    return (Common.STAGE_WIDTH + P3.View.width) * 0.5;
}

window.rhs = rhs;

